
// declare global {
// tslint:disable-next-line: interface-name
interface Array<T> {
    _sum: () => number;
    _min: () => number;
    _max: () => number;
    _count: (condition?: (el: T, idx?: number) => boolean) => number;
    _any: (condition?: (el: T, idx?: number) => boolean) => boolean;
    _all: (condition?: (el: T, idx?: number) => boolean) => boolean;
    _skip: (idx: number) => T[];
    _skipWhile: (condition: (el: T, idx?: number) => boolean) => T[];
    _select: <U>(mapper: (value: T, index: number) => U) => U[];
    _where: (condition: (value: T, index: number) => boolean) => T[];
    _orderBy: (comparer?: (a: T, b: T) => -1 | 0 | 1) => T[];
    _orderByDesc: (comparer?: (a: T, b: T) => -1 | 0 | 1) => T[];
    _first: (condition?: (value: T, index: number) => boolean) => T;
    _take: (count: number) => T[];
    _takeWhile: (condition: (el: T, idx?: number) => boolean) => T[];
    _distinct: (hashFnc?: (el: T) => string) => T[] | string[];
    _removeAll: (condition: (el: T, idx?: number) => boolean) => void;
}
//   }

if (!Array.prototype.reverse) {
    Array.prototype.reverse = function(): any[] {
        for (let i = 0; i < this.length / 2; i++) {
            const temp =  this[i];
            this[i] = this[this.length - i - 1];
            this[this.length - i - 1] = temp;
        }
        return this;
    };
}

Array.prototype._orderBy = function<T>(comparer?: (a: T, b: T) => -1 | 0 | 1): T[] {
    return this.slice().sort(comparer);
};

Array.prototype._orderByDesc = function<T>(comparer?: (a: T, b: T) => -1 | 0 | 1): T[] {
    return this.slice().sort(comparer).reverse();
};

Array.prototype._sum = function() {
    let sum = 0;
    for (let i = 0; i < this.length; i++) {
        sum += this[i];
    }
    return sum;
};

Array.prototype._min = function() {
    let res = this[0];
    for (let i = 1; i < this.length; i++) {
        if (this[i] < res) {
            res = this[i];
        }
    }
    return res;
};

Array.prototype._max = function() {
    let res = this[0];
    for (let i = 1; i < this.length; i++) {
        if (this[i] > res) {
            res = this[i];
        }
    }
    return res;
};

Array.prototype._count = function<T>(condition?: (el: T, idx?: number) => boolean): number {
    let counter = 0;
    for (let i = 0; i < this.length; i++) {
        if (condition == null || condition(this[i], i)) {
            counter++;
        }
    }
    return counter;
};

Array.prototype._any = function<T>(condition?: (el: T, idx?: number) => boolean): boolean {
    for (let i = 0; i < this.length; i++) {
        if (condition == null || condition(this[i], i)) {
            return true;
        }
    }
    return false;
};

Array.prototype._all = function<T>(condition: (el: T, idx?: number) => boolean): boolean {
    for (let i = 0; i < this.length; i++) {
        if (!condition(this[i])) {
            return false;
        }
    }
    return true;
};

Array.prototype._skip = Array.prototype.slice;

Array.prototype._skipWhile = function<T>(condition: (el: T, idx?: number) => boolean): T[] {
    const result: T[] = [];
    let i;
    for (i = 0; i < this.length; i++) {
        if (!condition(this[i], i)) {
            break;
        }
    }
    for (; i < this.length; i++) {
        result.push(this[i]);
    }
    return result;
};



Array.prototype._take = function<T>(count: number): T[] {
    return this.slice(0, count);
};

Array.prototype._takeWhile = function<T>(condition: (el: T, idx?: number) => boolean): T[] {
    const result: T[] = [];
    let i;
    for (i = 0; i < this.length; i++) {
        if (condition(this[i], i)) {
            result.push(this[i]);
        } else {
            return result;
        }
    }
    return result;
};

Array.prototype._where = Array.prototype.filter;
Array.prototype._select = Array.prototype.map;

Array.prototype._first = function<T>(condition?: (el: T, idx?: number) => boolean): T {
    return condition != null ? this.filter(condition)[0] : this[0];
};

Array.prototype._distinct = function<T>(hashFnc?: (el: T) => string): T[] | string[] {
    const dist: any = {};
    for (let i = 0; i < this.length; i++) {
        dist[hashFnc != null ? hashFnc(this[i]) : this[i]] = this[i];
    }
    const result = [];
    for (const o in dist) {
        if (dist.hasOwnProperty(o)) {
            result.push(dist[o]);
        }
    }
    return result;
};

Array.prototype._removeAll = function<T>(condition: (el: T, idx?: number) => boolean): void {
    for (let i = this.length - 1; i >= 0; i--) {
        if (condition(this[i], i)) {
            this.splice(i, 1);
        }
    }
};
